import axios from 'axios';
import { urlApiAsesoria } from '../Config/baseUrl';

import { IObtenerFotos, ISubirControlFotos } from '../Interfaces/FotoLlenado';

// const baseURL = baseUrlProduction;

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const subirControlFotos = (data: ISubirControlFotos) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/subirControl', data, config);
};

export const obtenerFotos = (data: IObtenerFotos) => {
  return axios.post(urlApiAsesoria + 'fit4/obtenerFotos', data, config);
};
